function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 343 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154606",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5970",
    d: "M115.058-840a2.729 2.729 0 0 1-2.007-.827 2.736 2.736 0 0 1-.825-2.007 6.159 6.159 0 0 1 .109-.767l-7.486-4.407a2.73 2.73 0 0 1-.9.618 2.827 2.827 0 0 1-1.122.224 2.713 2.713 0 0 1-2-.83 2.741 2.741 0 0 1-.824-2 2.741 2.741 0 0 1 .824-2 2.713 2.713 0 0 1 2-.83 2.827 2.827 0 0 1 1.122.224 2.73 2.73 0 0 1 .9.618l7.486-4.4a2.087 2.087 0 0 1-.086-.38 3.222 3.222 0 0 1-.023-.4 2.732 2.732 0 0 1 .827-2.007 2.737 2.737 0 0 1 2.009-.827 2.727 2.727 0 0 1 2.007.827 2.738 2.738 0 0 1 .825 2.009 2.729 2.729 0 0 1-.827 2.007 2.736 2.736 0 0 1-2.007.825 2.735 2.735 0 0 1-1.118-.229 2.812 2.812 0 0 1-.9-.623l-7.486 4.407a2.094 2.094 0 0 1 .086.38 3.225 3.225 0 0 1 .023.4 3.225 3.225 0 0 1-.023.4 2.1 2.1 0 0 1-.086.38l7.486 4.407a2.813 2.813 0 0 1 .9-.623 2.735 2.735 0 0 1 1.118-.229 2.732 2.732 0 0 1 2.007.827 2.737 2.737 0 0 1 .827 2.009 2.727 2.727 0 0 1-.827 2.007 2.739 2.739 0 0 1-2.009.817zm0-1.579a1.214 1.214 0 0 0 .894-.361 1.214 1.214 0 0 0 .361-.894 1.214 1.214 0 0 0-.361-.894 1.214 1.214 0 0 0-.894-.361 1.214 1.214 0 0 0-.894.361 1.214 1.214 0 0 0-.361.894 1.214 1.214 0 0 0 .361.894 1.214 1.214 0 0 0 .897.361zm-12.237-7.166a1.229 1.229 0 0 0 .9-.361 1.209 1.209 0 0 0 .364-.894 1.209 1.209 0 0 0-.364-.894 1.229 1.229 0 0 0-.9-.361 1.2 1.2 0 0 0-.887.361 1.219 1.219 0 0 0-.358.894 1.22 1.22 0 0 0 .358.894 1.2 1.2 0 0 0 .89.361zm12.237-7.166a1.214 1.214 0 0 0 .894-.361 1.214 1.214 0 0 0 .361-.894 1.214 1.214 0 0 0-.361-.894 1.215 1.215 0 0 0-.894-.361 1.215 1.215 0 0 0-.894.361 1.214 1.214 0 0 0-.361.894 1.214 1.214 0 0 0 .361.894 1.214 1.214 0 0 0 .897.361zm.003 13.077zM102.834-850zm12.227-7.166z",
    transform: "translate(-97 862)",
    style: {
      fill: "#121212"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMShare);
export default __webpack_public_path__ + "static/media/m_share.6e2cb9574c380c2c97d4eb120212185f.svg";
export { ForwardRef as ReactComponent };